import { useSearchspringContext } from '../fetchers/provider'
import { useEffect, useMemo, useState } from 'preact/hooks'
import { FilterItem, FilterSizeItem } from './FilterItem'
import { useOption } from '../hooks/useOption'
import { FilterSelected } from './FilterSelected'
import { parseFiltersFromResults } from './FilterUtils'
import { useFilters } from '../hooks/useFilters'

export function FilterSidebar() {
  const { results, refine } = useSearchspringContext()

  const { handleToggleFilter, handleRemoveFilter, handleClearFilters, handleRemoveAllByField } = useFilters()

  const activeFilters = useOption('filters', {
    defaultValue: new Set(),
    syncWithURL: true
  })
  const { fetchedFilters, sizeFilters } = useMemo(() => parseFiltersFromResults(results), [results])
  const [initialFilters, setInitialFilters] = useState(fetchedFilters)
  const [initialSizeFilters, setInitialSizeFilters] = useState(sizeFilters)

  useEffect(() => {
    if (initialFilters.length === 0) {
      setInitialFilters(fetchedFilters)
    }
    if (initialSizeFilters.length === 0) {
      setInitialSizeFilters(sizeFilters)
    }
  }, [fetchedFilters])

  return (
    <div className="sticky flex flex-col top-28 max-h-[calc(100dvh-7rem)] overflow-auto">
      <div className="border-b border-neutrals-medium-grey">
        <p className="mb-4 h4">Filters</p>
      </div>
      <FilterSelected activeFilters={activeFilters} onRemove={handleRemoveFilter} onClear={handleClearFilters} />
      <div className="flex flex-col flex-grow overflow-y-auto divide-y divide-neutrals-medium-grey">
        {initialFilters.map((filter) => (
          <FilterItem
            filter={filter}
            onFilter={handleToggleFilter}
            fetchedFilters={fetchedFilters}
            activeFilters={activeFilters}
            key={filter.field}
            removeAll={handleRemoveAllByField}
          />
        ))}
        {initialSizeFilters.length > 0 && (
          <FilterSizeItem
            initialFilters={initialSizeFilters}
            onFilter={handleToggleFilter}
            fetchedFilters={sizeFilters}
            activeFilters={activeFilters}
          />
        )}
      </div>
      {typeof window !== 'undefined' && window.collection?.filters?.banner_image && (() => {
        const bannerUrl = window.collection.filters.banner_url
        const bannerImage = window.collection.filters.banner_image
        const bannerMobileImage = window.collection.filters.banner_mobile_image
        const className = `w-full h-fit mt-8 overflow-hidden ${bannerMobileImage ? 'mob-alt_lg' : ''}`
        const imageContent = (
          <>
            <img
              src={bannerImage?.src || bannerImage}
              alt=""
              className="w-full h-fit"
            />
            {bannerMobileImage && (
              <img
                src={bannerMobileImage?.src || bannerMobileImage}
                alt=""
                className="w-full h-fit"
              />
            )}
          </>
        )

        return bannerUrl ? (
          <a href={bannerUrl} aria-label="Filters banner link" className={className}>
            {imageContent}
          </a>
        ) : (
          <div className={className}>
            {imageContent}
          </div>
        )
      })()}
    </div>
  )
}
